import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Store } from 'antd/lib/form/interface';
import { Layout, Table, Input, Select } from 'antd';
import { CriteriaForm, AuthButton, Checkbox } from '../../core/CoreForm';
import { ContentEx as Content, FunctionTitle, CommonMessage } from '../../core/CorePageContents';
import styles from './certificationProjectSelect.module.css';
import * as Module from '../../../modules/prime/certificationProjectSelect/certificationProjectSelectModule';
import * as Model from '../../../modules/prime/certificationProjectSelect/certificationProjectSelectModel';
import { initMessages } from '../../../modules/core/commonMessageModule';
import * as CONSTANTS from '../../../constants/constants';
import { initApiResult, storedApiResult } from '../../../modules/core/bffApiModule';
import * as qualificationHoldersModule from '../../../modules/prime/qualifications-holders/qualificationHoldersModule';

interface titleInterface {
  title: string;
}

export const CertificationProjectSelect = (props: titleInterface) => {

  const dispatch = useDispatch();
  let dataList = useSelector(Module.storedDataList);
  let selectDataList = useSelector(Module.storedSelectDataList);
  let dataCriteria = useSelector(Module.storedDataCriteria);
  let totalCnt = useSelector(Module.storedDataTotal);
  // 取得したプロジェクト一覧の選択情報（左）
  let modalSelectValues = useSelector(Module.storedModalSelectValues);
  // 対象プロジェクト一覧の選択情報（右）
  let modalConfirmValues = useSelector(Module.storedModalConfirmValues);
  const branchList_summary = useSelector(Module.storedBranchList_summary);
  const filterdBranchList_summary = branchList_summary.filter(branch => branch.branchId !== "");
  const belongCompanyData = useSelector(qualificationHoldersModule.storedBelongCompanyDataRow);
  let currentPage = useSelector(Module.storedDataCurrentPage);
  const firstFlag = useSelector(Module.storedFirstFlag);
  const apiResult = useSelector(storedApiResult);

  useEffect(() => {
    // API処理結果を初期化します。
    dispatch(initApiResult());
    let criteria: Model.CertificationProjectCriteria = {
      branchId: dataCriteria.branchId,
      projectName: dataCriteria.projectName,
      belongCompanyId: belongCompanyData.belongCompanyId
    }
    dispatch(Module.getDataListAsync(criteria, firstFlag));
    dispatch(Module.setCurrentPage(1));
  },
    [dataCriteria]
  );

  useEffect(() => {
    viewEmptyCertificationProjectTable();
  },
    [apiResult]
  );

  useEffect(() => {
    viewEmptyCertificationProjectTable();
  },
    [selectDataList]
  );

  // 対象プロジェクト選択ダイアログのテーブルが0行の時の処理
  const viewEmptyCertificationProjectTable = () => {
    // 0行になったとき、ant designのテーブルが作成する「No Data」行を非表示にする（0行になったとき"ant-table-placeholder"が存在する）
    const leftTableElem: HTMLElement | null = document.getElementById("certificationProjectLeftTable");
    const rightTableElem: HTMLElement | null = document.getElementById("certificationProjectRightTable");
    if (leftTableElem != null) {
      const phRow: HTMLElement | null = leftTableElem.querySelector(".ant-table-placeholder");
      if (phRow != null) {
        phRow.style.display = "none";
      }
    }
    if (rightTableElem != null) {
      const phRow: HTMLElement | null = rightTableElem.querySelector(".ant-table-placeholder");
      if (phRow != null) {
        phRow.style.display = "none";
      }
    }
  }

  // プロジェクト検索モーダル検索ボタン押下時イベント
  const searchProjectDataList = (value: Store) => {
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());
    let criteria: Model.CertificationProjectCriteria = {
      branchId: value.branchId,
      projectName: value.projectName,
      belongCompanyId: belongCompanyData.belongCompanyId
    }
    dispatch(Module.setFirstFlag(false));
    dispatch(Module.setCriteria(criteria));
  }

  //　ページング選択時イベント
  const handleTableChange = (pagination: any) => {
    dispatch(Module.setCurrentPage(pagination.current));
  }

  const reflectSelectValue = (record: Model.CertificationProjectSelectRow) => {
    // 選択値を保持
    dispatch(Module.reflectModalSelectValue(record))
  }

  const reflectConfirmValue = (record: Model.CertificationProjectSelectRow) => {
    // 選択値を保持
    dispatch(Module.reflectModalConfirmValue(record))
  }

  // チェックボックスのフォーマット
  const checkboxFormatter = (value: string, row: Model.CertificationProjectSelectRow) => {
    return (
      <Checkbox checked={modalSelectValues.includes(row) ? true : false} value={row.projectId} />
    )
  }

  // チェックボックスのフォーマット
  const checkboxFormatterConfirm = (value: string, row: Model.CertificationProjectSelectRow) => {
    return (
      <Checkbox checked={modalConfirmValues.includes(row) ? true : false} value={row.projectId} />
    )
  }

  const columns = [
    {
      title: "選択",
      align: "center" as "center",
      width: 60,
      render: checkboxFormatter,
    },
    {
      title: 'プロジェクト名',
      dataIndex: 'projectName',
      align: 'center' as 'center',
      width: 350
    },
  ]

  const selectColumns = [
    {
      title: "選択",
      align: "center" as "center",
      width: 60,
      render: checkboxFormatterConfirm,
    },
    {
      title: '対象プロジェクト',
      dataIndex: 'projectName',
      align: 'center' as 'center',
      width: 350
    },
  ]

  // プロジェクト検索モーダル検索フォームを描画します。
  const SearchProjectCriteria = () => {
    return (
      <CriteriaForm layout="inline" onFinish={searchProjectDataList}
        initialValues={
          dataCriteria.branchId == ""
          ? {"projectName": dataCriteria.projectName } // こうしないと未選択時にプレースホルダーが表示されない
          : {"branchId": dataCriteria.branchId, "projectName": dataCriteria.projectName }
        }
      >
        <div className={styles.criteriaSearchField}>
          <CriteriaForm.Item name="branchId">
            <Select 
              className={styles.branch}
              placeholder="支店"
            >
              <Select.Option key="ALL" value={"ALL"}>(すべて)</Select.Option>
              {filterdBranchList_summary.map((rec: Model.branch) => (
                <Select.Option key={rec.branchId} value={rec.branchId}>{rec.branchName}</Select.Option>
              ))}
            </Select>
          </CriteriaForm.Item>
          <CriteriaForm.Item name="projectName">
            <Input type="text" placeholder="プロジェクト名" maxLength={CONSTANTS.PROJECT_NAME_MAX_LENGTH} />
          </CriteriaForm.Item>
          <AuthButton name={"検索"} htmlType="submit" shape="round" />
        </div>
      </CriteriaForm>
    )
  }

  // ページングボタンを描画します。
  const pageItemRender = (page: any, type: string, originalElement: any) => {
    if (type === 'prev') {
      return <AuthButton name='＜' size='small' />;
    }
    if (type === 'next') {
      return <AuthButton name='＞' size='small' />;
    }
    return originalElement
  }

  // プロジェクトを追加
  const addProject = () => {
    dispatch(Module.addSelectDataList());
    dispatch(Module.setCurrentPage(1));
  }

  return (
    <Layout className={styles.layout}>
      <Content>
        <FunctionTitle title={props.title} />
        <SearchProjectCriteria />
        <CommonMessage />
        <>
          <div style={{display: "flex", justifyContent: "space-between"}}>
            <div style={{width: "45%"}}>
            <Table
              id="certificationProjectLeftTable"
              style={{width: "100%"}}
              columns={columns}
              dataSource={dataList}
              size='small'
              rowKey="projectId"
              scroll={{ x: 430, y: 260 }}
              // pagination={false}
              pagination={{
                total: totalCnt  //総件数
                , defaultCurrent: 1 //
                , defaultPageSize: 100
                , current: currentPage
                , pageSize: dataCriteria.limit //ページサイズを入れる
                , pageSizeOptions: ['5', '10', '20', '50', '100']
                , showSizeChanger: true
                , showTotal: (total, range) => `${total}件中、${range[0]}件目から${range[1]}件目を表示`
                , itemRender: pageItemRender
                , locale: { items_per_page: '件/ページ' }
              }}
              onChange={(pagination) => handleTableChange(pagination)}
              onRow={(record) => {
                return {
                  onChange: event => { reflectSelectValue(record) }
                };
              }}
            />
            </div>
            <div style={{width: "10%", display: "flex", justifyContent: "center", alignItems: "center"}}>
              <AuthButton
                name={"追加 >>"}
                size={"middle"}
                shape={"round"}
                onClick={addProject}
                style={{ margin: "10px" }}
              />
            </div>
            <div style={{width: "45%"}}>
            <Table
              id="certificationProjectRightTable"
              style={{width: "100%"}}
              columns={selectColumns}
              dataSource={selectDataList}
              size='small'
              rowKey="projectId"
              scroll={{ x: 430, y: 270 }}
              pagination={false}
              onRow={(record) => {
                return {
                  onChange: event => { reflectConfirmValue(record) }
                };
              }}
            />
            </div>
          </div>
        </>
      </Content>
    </Layout>
  );
}